import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';

export default withStyles({
    tooltip: {
        borderRadius: '8px',
        fontWeight: 500,
        fontSize: '12px',
        padding: '6px 12px',
        background: '#000',
        color: '#fff',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        textAlign: 'center'
    },
    arrow: {
        color: '#000'
    }
})(Tooltip);
